import { makeAutoObservable } from 'mobx';
import {api} from 'shared/core';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import {TimeTrackingDimension} from 'main/stores/time_tracking';
import _ from 'lodash';

class DimensionDirectoryState {
  store = new DomainStore();

  dimensions = [];
  editingDimension = {};
  reorderingDimensions = [];
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([endpoints.TIME_TRACKING.DIMENSIONS.ALL]);

    this.dimensions = this.store._getAll(types.TIME_TRACKING.DIMENSION, TimeTrackingDimension);
  }

  get sortedDimensions() {
    return _.sortBy(this.dimensions, 'order');
  }

  async saveDimension() {
    const {model, errors} = this.editingDimension.isNew ?
      await this.store.post(endpoints.TIME_TRACKING.DIMENSIONS.ALL, types.TIME_TRACKING.DIMENSION, this.editingDimension) :
      await this.store.patch(this.editingDimension);
    this.errors = errors;

    if (model) {
      this.closeEditDimensionModal();
      await this.load();
    }
  }

  openRemoveDimensionModal() {
    this.closeEditDimensionModal();
  }

  async removeDimension() {
    await this.store.destroy(this.editingDimension);
    this.closeRemoveDimensionModal();
    await this.load();
  }

  openReorderDimensionsModal() {
    this.reorderingDimensions = this.sortedDimensions.map(dimension => new TimeTrackingDimension(dimension));
  }

  async saveDimensionOrders() {
    const dimensions = {};
    this.reorderingDimensions.forEach(dimension => dimensions[dimension.id] = dimension.order);

    await api.patch(endpoints.TIME_TRACKING.DIMENSIONS.REORDER, {dimensions});

    await this.load();
    this.closeReorderDimensionsModal();
  }
}

export default DimensionDirectoryState;
